import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { computed, makeObservable } from "mobx";
import { fromPromise } from "mobx-utils";
import isDefined from "../../Core/isDefined";
import SearchProviderMixin from "./SearchProviderMixin";
function CatalogSearchProviderMixin(Base) {
  var _class;
  let CatalogSearchProviderMixin = (_class = class CatalogSearchProviderMixin extends SearchProviderMixin(Base) {
    constructor() {
      super(...arguments);
      makeObservable(this);
    }
    get resultsAreReferences() {
      var _this$terria$catalogI;
      return isDefined((_this$terria$catalogI = this.terria.catalogIndex) === null || _this$terria$catalogI === void 0 ? void 0 : _this$terria$catalogI.loadPromise) && fromPromise(this.terria.catalogIndex.loadPromise).state === "fulfilled";
    }
    get hasCatalogSearchProviderMixin() {
      return true;
    }
  }, _applyDecoratedDescriptor(_class.prototype, "resultsAreReferences", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "resultsAreReferences"), _class.prototype), _class);
  return CatalogSearchProviderMixin;
}
(function (_CatalogSearchProviderMixin) {
  function isMixedInto(model) {
    return model && model.hasCatalogSearchProviderMixin;
  }
  _CatalogSearchProviderMixin.isMixedInto = isMixedInto;
})(CatalogSearchProviderMixin || (CatalogSearchProviderMixin = {}));
export default CatalogSearchProviderMixin;